import React from "react";

import Editor from './EditorBloger'
import EditorWrapper from '../../EditorWrapper'

import Quote from "../../common/Quote";
import EmptyArticle from "../../common/EmptyArticle";

const AQuote = props => {
  var article = EmptyArticle();
  const settings = props.settings;
  const imageUrl = (settings['background-image'] ? settings['background-image'] : '');

  article.url = settings.link;
  article.title = settings.title_normal;
  article.intro = settings.blog_text;
  article.author.img = window.MEDIA_DOMAIN + '/' + imageUrl.replace('.', ',780,0,0,0.');
  article.author.name = settings.blog_author;

  // props.onRegisterBox(props.blockId, props.id, 'title_normal')

  return (
    <div className={props.classes + ' pos-relative'} {...props.events}>
      <EditorWrapper {...props} editor={Editor} />
      <Quote article={article} />
    </div>
  );
};

export default AQuote;
